<template>
  <div class="menuTitle">
    <button class="home-button" @click="$router.push('/')">
      <a>
        <img src="@/assets/button-style/arrow-back.svg" >
      </a>
    </button>
    <label v-if="this.$route.name == 'challengeChildApprove'" class="menu-title">My Challenges</label>
    <label v-if="this.$route.name == 'Badges'" class="menu-title">My Badges</label>
    <label v-if="this.$route.name == 'Rewards'" class="menu-title">My Rewards</label>
    <label v-if="this.$route.name == 'Progress'" class="menu-title">My Progress</label>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("user", [
      "getUserName",
      "userIsAParent",
      "getUserScore",
      "getUserScoreAll",
      "getUserLevel"
    ]),
  },
};
</script>
<style lang="scss" scoped>
* {
  position: relative;
  margin: 0;
  padding: 0;
}

.menuTitle{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  padding: auto;
  gap: calc(1vw + 0.5rem);
}


.menu-title {
  color: #2C2164;
  font-size: calc(2.25vw + 0.7rem);
}

.home-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  outline: none;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  & > a {
    display: flex;
    width: 50%;
    height: 50%;
  }
}
</style>